import { FC, SyntheticEvent, useState } from 'react';

import { Box, useTheme, Tab, Tabs, BoxProps } from '@mui/material';
import { scroller } from 'react-scroll';

import Container from '@components/store/container';

export type ProductNavigationMenuItem = {
  label: string;
  value: string;
  sx?: BoxProps['sx'];
};

type ProductNavigationMenuProps = {
  defaultMenu: string;
  menus: ProductNavigationMenuItem[];
  customScrollOffset?: Record<string, number>;
};

const ProductNavigationMenu: FC<ProductNavigationMenuProps> = ({ defaultMenu, menus, customScrollOffset }) => {
  const theme = useTheme();

  const [selectedMenu, setSelectedMenu] = useState<string>(defaultMenu);

  const handleChangeMenu = (_event: SyntheticEvent, newValue: string) => {
    setSelectedMenu(newValue);

    scroller.scrollTo(newValue, {
      duration: 0,
      smooth: true,
      offset: customScrollOffset?.[newValue] || -120,
    });
  };

  return (
    <Box sx={{ position: 'sticky', top: 64, zIndex: 1, background: theme.palette.grey[100] }}>
      <Container>
        <Tabs
          sx={{ height: 60 }}
          value={selectedMenu}
          onChange={handleChangeMenu}
          TabIndicatorProps={{ style: { height: 6, borderRadius: 3 } }}
        >
          {menus.map((menu) => {
            return (
              <Tab
                key={menu.value}
                label={menu.label}
                value={menu.value}
                sx={{
                  py: '18px',
                  color: menu.value === selectedMenu ? theme.palette.primary.main : theme.palette.common.black,
                  ...menu.sx,
                }}
              />
            );
          })}
        </Tabs>
      </Container>
    </Box>
  );
};

export default ProductNavigationMenu;
